export default __webpack_public_path__ + "static/media/quotes.bfcc3ada.svg";